import React from 'react'
import { archivoCVAPI } from '../../utils/funcionesAPI'
import {manejadorDeRespuesta} from '../../utils/Tools'
import {toast, ToastContainer } from 'react-toastify'
import { RUTA_IMAGEN } from '../../utils/rutasFijas'

const TrabajaConNosotros = (props) => {

  window.scrollTo(0,0);

  function handleEnviarCVClick(e) {
    e.preventDefault();

    const nombre = document.getElementById('nombre');
    const mail = document.getElementById('mail');
    const adjunto = document.getElementById('archivo');

    if (nombre.value === "" || mail.value === "" || adjunto.value === "") {
      toast.error('Debe completar todos los campos', {
        position: toast.POSITION.BOTTOM_CENTER
        });
      return false;
    }

    var form = document.getElementById('formCurriculum');
    var formData = new FormData(form);
    formData.append('accion', 'enviarCurriculumPorMail');

    toast.info("Enviando...", {
                        position: toast.POSITION.BOTTOM_CENTER
                        });
    archivoCVAPI(formData)
            .then(respuesta => {
              if(manejadorDeRespuesta(props, respuesta))
                toast.success(respuesta.data, {
                                    position: toast.POSITION.BOTTOM_CENTER
                                    });
                document.getElementById("formCurriculum").reset();
            });
  }

  return (
    <section className="sobre-pedraza trabajaConNosotros">
    <div className="container">
      <div className="row">
        <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1>TE ESTAMOS BUSCANDO</h1>
          <hr />
          <h6>Puestos disponibles</h6>
            <p>.Administrativo/a</p>
            <p>.Marketing</p>
            <p>.Coordinador/a</p>
            <p>.Operativo/a</p>       
        </article>
      </div>
      <form id="formCurriculum" style={{textAlign: 'left'}}>
        <div className="form-group d-inline-block col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <label className="labelForm">Carga tu CV a continuacion</label>
          <label className="labelForm" htmlFor="nombre">Nombre y Apellido</label>
          <input id="nombre" className="form-control" type="text" name="nombre" required placeholder="Nombre y Apellido" />
        </div>

        <div className="form-group d-inline-block col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <label className="labelForm" htmlFor="nombre">Mail</label>
          <input id="mail" className="form-control" type="text" name="puesto" required placeholder="Mail" />
        </div>

        <div className="form-group d-inline-block col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <label className="labelForm" htmlFor="archivo">Adjuntar CV (.doc, .pdf)</label>
          <input id="archivo" className="form-control" type="file" name="archivo" required placeholder="C.V." />
        </div>

        <div className="form-group d-inline-block col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <img alt="Icono de busqueda" width="250" src={`${RUTA_IMAGEN}sobrePedraza/busqueda_ic.png`} />
        </div>

        

        <div className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <input style={{backgroundColor: '#181e35', color: '#fff', fontSize: 'x-large'}} className="botonInicio" type="submit" value="Cargar" onClick={handleEnviarCVClick} />
        </div>

      </form>
      <ToastContainer />
    </div>
  </section>
  )
}

export default TrabajaConNosotros



// WEBPACK FOOTER //
// ./src/components/Global/TrabajaConNosotros.js